<script lang="ts">
  import type { DropdownListOption } from '$shared/components/types';
  import { DropdownListType } from './DropdownListProps';
  import List from './partial/List.svelte';
  import SearchableList from './partial/SearchableList.svelte';

  interface Props {
    list?: CommonList[];
    maxheight?: boolean;
    option?: DropdownListOption;
    onclick?: (item: CommonList) => void;
    oncreate?: (value: string) => void;
    oninputcreate?: (value: string) => void;
  }

  let { list = [], maxheight = false, option = {}, onclick, oncreate, oninputcreate }: Props = $props();

  let searchableListElement: SearchableList = $state();

  export const focus = (): void => {
    searchableListElement?.focus();
  };
</script>

<div class="comp-dropdown-list" class:maxheight>
  {#if option?.type === DropdownListType.Searchable}
    <SearchableList
      {maxheight}
      {list}
      placeholder={option?.searchPlaceholder}
      canCreate={!!option?.canCreate}
      canCreateOnInput={!!option?.canCreateOnInput}
      bind:this={searchableListElement}
      {onclick}
      {oncreate}
      {oninputcreate}
    />
  {:else}
    <List {list} {maxheight} {onclick} />
  {/if}
</div>

<style src="./DropdownList.css">
</style>
